import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import TaxInhouseField from '../../form/fields/TaxInhouseField';
import { connect } from 'react-redux';
import {
  closeModalSafely,
  handleSubmit,
} from './category-level-bulk-edit.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import {
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuEntries,
  fetchMenuItems,
} from '../../../../redux/store/store.actions';
import {
  setIsEditCategoryBulkModalOpen,
  setEditCategoryBulkModalData,
} from '../../../../redux/modal/modal.actions';
import TaxTakeawayField from '../../form/fields/TaxTakeawayField';
import AdditionGroupsField from '../../form/fields/AdditionGroupsField';
import FormattedNumberField from '../../form/fields/FormattedNumberField';
import { getOrderConditionsCollapsable } from '../modals.service';
import DropdownField from '../../form/fields/DropdownField';
import { useRef } from 'react';
import {
  getCurrencySuffix,
  transformMenuEntries,
} from '../../../../utility/util/util.service';

const CategoryLevelBulkEdit = ({
  isEditCategoryBulkModalOpen,
  editCategoryBulkModalData,

  intl,
  store,
  additionGroups,
  allMenuEntries,
  pickupStations,
  items,
  itemDatas,
  itemAdditions,
  itemAdditionGroups,
  foodAllergens,
  foodAdditives,
  foodPreferences,
  foodIngredients,
  allItemCategories,

  setIsEditCategoryBulkModalOpen,
  setEditCategoryBulkModalData,
  fetchMenuEntries,
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuItems,
}) => {
  const [targetItemData, setTargetItemData] = useState({});
  const [serviceTimesLocalState, setServiceTimesLocalState] = useState([[]]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOrderConditionsOpen, setIsOrderConditionsOpen] = useState(false);
  const [targetOrderConditions, setTargetOrderConditions] = useState([]);
  const [isAddOrderConditionOpen, setIsAddOrderConditionOpen] = useState(false);
  const [selectedOrderCondition, setSelectedOrderCondition] = useState(null);
  const [newOrderCondition, setNewOrderCondition] = useState({
    isActive: true,
    priority: 10,
    minTotal: 0,
    maxTotal: null,
    minQty: 0,
    maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
    classes: ['inhouse', 'takeaway'],
  });
  const formRef = useRef(null);

  const isOpen = isEditCategoryBulkModalOpen;
  const isEditMode = true; // i want to trigger patch method in modals service

  const targetCategory = editCategoryBulkModalData?.category;

  const itemDataEntriesInCategory =
    allMenuEntries &&
    transformMenuEntries({
      menuEntries: allMenuEntries,
      items,
      itemDatas,
      itemAdditions,
      itemAdditionGroups,
      itemCategories: allItemCategories,
      foodAllergens,
      foodAdditives,
      foodPreferences,
      foodIngredients,
    })
      ?.filter(
        (menuEntry) =>
          menuEntry?.category &&
          targetCategory?.id &&
          menuEntry?.type === 'ItemMenuEntry' &&
          menuEntry.category.id === targetCategory.id,
      )
      ?.map((item) => item?.itemEntry)
      ?.flatMap(({ data }) => data);

  const _getOrderConditionsCollapsable = () =>
    getOrderConditionsCollapsable(
      targetOrderConditions,
      setTargetOrderConditions,
      isOrderConditionsOpen,
      setIsOrderConditionsOpen,
      userLocale,
      isSubmitting,
      intl,
      isAddOrderConditionOpen,
      setIsAddOrderConditionOpen,
      newOrderCondition,
      setNewOrderCondition,
      'orderConditionsTitle',
      true,
      selectedOrderCondition,
      setSelectedOrderCondition,
      true,
    );

  const closeModal = () => {
    setIsOrderConditionsOpen(false);
    setIsAddOrderConditionOpen(false);
    setTargetItemData({});
    setTargetOrderConditions([]);
    setServiceTimesLocalState([[]]);
    setSelectedOrderCondition(null);
    setNewOrderCondition({
      priority: null,
      minTotal: 0,
      maxTotal: null,
      minQty: 0,
      maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
      classes: ['inhouse', 'takeaway'],
    });
    setIsEditCategoryBulkModalOpen(false);
    setEditCategoryBulkModalData(null);
  };
  const userLocale = intl?.locale;

  useEffect(() => {
    if (isOpen) {
      // reset modal on opening
    } else {
      // reset modal on closing
    }
  }, [editCategoryBulkModalData, isOpen, store]);

  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);
  const _handleSubmit = (event, errors, values) => {
    handleSubmit(
      event,
      errors,
      values,
      targetItemData,
      isEditMode,
      setIsSubmitting,
      setTargetItemData,
      closeModal,
      async () => {
        const menuId = store?.menu?.id;
        const storeId = store?.id;
        await Promise.all([
          fetchFoodItemAdditions(true, menuId, undefined, storeId),
          fetchMenuItems(true, menuId, undefined, storeId),
          fetchItemDatas(true, menuId, undefined, storeId),
        ]);
        await fetchAdditionGroups(true, menuId, undefined, storeId);
        return new Promise((resolve, reject) => {
          fetchMenuEntries(
            menuId,
            true,
            () => {
              resolve(setServiceTimesLocalState); // Resolve the promise with setServiceTimesLocalState
            },
            storeId,
          );
        });
      },
      targetOrderConditions,
      newOrderCondition,
      isAddOrderConditionOpen,
      itemDataEntriesInCategory,
      store?.id,
    );
  };

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      title={intl.formatMessage({ id: 'editCategoryLevelBulkTitle' })}
      footer={
        <div className="align-content-center">
          <SaveSubmitButton
            onClick={() => formRef?.current.handleSubmit()}
            data-testid="submitItemButton"
            className="m-auto"
            isSubmitting={isSubmitting}
          />
        </div>
      }
    >
      <div className="px-1">
        <AvForm ref={formRef} onSubmit={_handleSubmit} disabled={isSubmitting}>
          <div className="mt-2">
            <Row>
              <Col xs={6} className="pr-50">
                <FormattedNumberField
                  propName="priceInhouse"
                  object={targetItemData}
                  suffixSign={getCurrencySuffix(store?.currency)}
                />
              </Col>
              <Col xs={6} className="pl-50">
                <TaxInhouseField
                  data-testid="taxInhouse"
                  object={targetItemData}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6} className="pr-50">
                <FormattedNumberField
                  propName="priceTakeaway"
                  object={targetItemData}
                  suffixSign={getCurrencySuffix(store?.currency)}
                />
              </Col>
              <Col xs={6} className="pl-50">
                <TaxTakeawayField
                  data-testid="taxTakeaway"
                  object={targetItemData}
                />
              </Col>
            </Row>
            <AdditionGroupsField
              propertyName="additionGroupIds"
              object={targetItemData}
              setter={setTargetItemData}
              options={additionGroups || []}
              isDisabled={isSubmitting}
              store={store}
            />
            {/* <DropdownField
              isMulti={true}
              options={pickupStations}
              propertyName="pickupStations"
              object={targetItemData}
              placeholderMessageId="pickupStationsLabel"
              labelMessageId="pickupStationsTitle"
              required
            /> */}
            {_getOrderConditionsCollapsable()}
          </div>
        </AvForm>
      </div>
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isEditCategoryBulkModalOpen: state.modals.isEditCategoryBulkModalOpen,
  editCategoryBulkModalData: state.modals.editCategoryBulkModalData,
  allAdditions: state.store.foodItemAdditions,
  allAllergens: state.store.foodAllergens,
  allPreferences: state.store.foodPreferences,
  allIngredients: state.store.foodIngredients,
  allAdditives: state.store.foodAdditives,
  allMenuEntries: state.store.menuEntries,
  menu: state.store.menu,
  store: state.store.store,
  additionGroups: state.store.additionGroups,
  pickupStations: state.store.pickupStations,
  allItemCategories: state.store.itemCategories,
  items: state.store.items,
  itemDatas: state.store.itemDatas,
  itemAdditions: state.store.foodItemAdditions,
  itemAdditionGroups: state.store.additionGroups,
  foodAllergens: state.store.foodAllergens,
  foodAdditives: state.store.foodAdditives,
  foodPreferences: state.store.foodPreferences,
  foodIngredients: state.store.foodIngredients,
});

export default connect(mapStateToProps, {
  setIsEditCategoryBulkModalOpen,
  setEditCategoryBulkModalData,
  fetchMenuEntries,
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuItems,
})(injectIntl(CategoryLevelBulkEdit));
